import {
  NotificationAction,
  RESET_NOTIFICATION,
  SET_NOTIFICATION,
} from "store/types/notification.types";
import { GlobalState } from "store/configure-store";
import { NotificationTypeEnum } from "common/enums/NotificationTypeEnum";

export interface NotificationState {
  type: NotificationTypeEnum;
  message?: string;
  correlationId?: string;
}

export const initialNotificationContextState: NotificationState = {
  type: NotificationTypeEnum.NOTHING,
};

/** ---- SELECTORS ---- */
export const selectNotificationType = (
  state: GlobalState
): NotificationTypeEnum => {
  return state.notificationContext.type;
};

export const selectNotificationMessage = (
  state: GlobalState
): string | undefined => {
  return state.notificationContext.message;
};

export const selectCorrelationId = (state: GlobalState): string | undefined => {
  return state.notificationContext.correlationId;
};

/** ---- ACTION HANDLERS ---- */
const setNotification = (
  notificationState: NotificationState
): NotificationState => {
  return notificationState;
};

const resetNotification = (state: NotificationState): NotificationState => {
  return {
    ...state,
    type: NotificationTypeEnum.NOTHING,
    message: undefined,
    correlationId: undefined,
  };
};

/** ---- REDUCER ---- */
export const notificationReducer = (
  state = initialNotificationContextState,
  action: NotificationAction
): NotificationState => {
  switch (action.type) {
    case SET_NOTIFICATION:
      return setNotification(action.payload);
    case RESET_NOTIFICATION:
      return resetNotification(state);
    default:
      return state;
  }
};
